module.exports = __webpack_public_path__ + "static/icons/snowing@3x-fac913b4806e663682a62c04f44cf191.png";